export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6984.ceb62722.jpg";